import React, { Component } from 'react';
import Select from 'react-select';
import { Col, Row } from 'reactstrap';

import DatePicker from '../formFields/DatePicker';
import EngagementCharts from './EngagementCharts';
import MonetizationCharts from './MonetizationCharts';
import Loader from '../loader/Loader';
import AddAppAlert from '../alert/AddAppAlert';
import { ALL_APPS } from '../../utils/constants';

export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.onDatesChange = this.onDatesChange.bind(this);
  }

  componentDidMount() {
    const { apps, appsLoading, fetchAllReports } = this.props;
    if (appsLoading || (!appsLoading && apps.length > 1)) {
      const hash = window.location.hash;
      const appName = hash ? hash.substring(2) : '';
      fetchAllReports(null, null, appName, appsLoading);
    }
  }

  onFilterChange(selectedApp) {
    const {
      history,
      location: { pathname }
    } = window;
    if ('pushState' in history) {
      const appName =
        selectedApp.value === ALL_APPS
          ? ''
          : '#!' + encodeURIComponent(selectedApp.value);
      history.pushState(null, '', pathname + appName);
    }

    this.props.filterReports(selectedApp.value);
  }

  onDatesChange(startDate, endDate) {
    this.props.fetchAllReports(startDate, endDate);
  }

  render() {
    const { apps, app, analytics, revenues, appsLoading, loading } = this.props;
    const hasNoApps = !appsLoading && apps.length === 1;
    const selectStyles = {
      control: styles => ({
        ...styles,
        height: '2.2rem',
        minHeight: '2.2rem',
        backgroundColor: '#fff',
        borderColor: '#f2f2f2',
        borderRadius: '5px',
        alignContent: 'center',
        font: '400 1rem Poppins',
        color: '#555'
      })
    };

    return (
      <div>
        <Row>
          {hasNoApps &&
            !localStorage.getItem('hideNoAppAlert') && <AddAppAlert />}
          <Col lg="9">
            <DatePicker
              onChange={this.onDatesChange}
              disabled={loading || hasNoApps}
            />
          </Col>
          <Col lg="3">
            {!apps ? (
              ''
            ) : (
              <Select
                name="app-filter"
                value={{ label: app, value: app }}
                onChange={this.onFilterChange}
                options={apps.map(app => ({ label: app, value: app }))}
                clearable={false}
                isDisabled={loading || hasNoApps}
                className="form__form-group-select"
                placeholder="Select App"
                styles={selectStyles}
              />
            )}
          </Col>
        </Row>
        <Loader loaded={loading && !hasNoApps}>
          <Row className="dashboard-charts justify-content-between">
            <EngagementCharts {...analytics} />
            <MonetizationCharts {...revenues} />
          </Row>
        </Loader>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/Dashboard.js